import * as React from 'react';
import { PageWrap } from '../../layouts';
import { LottieWrapper } from './index';

const NoEmbedCodePage: React.FC<{}> = () => {
  return (
    <PageWrap alignItems="center" flexDirection="column" justifyContent="center">
      <LottieWrapper width={400} height={'auto'} loop={true} anim={require('../../assets/lottie/me_at_office.json')} />
      No Insight has been added to your user or to your Organization.
      Please Create an Insight.
    </PageWrap>
  );
};

export default NoEmbedCodePage;
